import LinkifyIt from 'linkify-it';

const linkifyItInstance = new LinkifyIt({});
/**
 * Type of the link match
 * @example
 * ```ts
 * {"schema":"","index":15,"lastIndex":25,"raw":"google.com","text":"google.com","url":"http://google.com"}
 * ```
 */
type LinkifyItMatch = {
    schema: unknown;
    index: number;
    lastIndex: number;
    raw: string;
    text: string;
    url: string;
};
export const getTheFirstUrlFromString = (content: string): string | undefined => {
    try {
        // see http://markdown-it.github.io/linkify-it/doc/#LinkifyIt.prototype.test
        if (linkifyItInstance.test(content)) {
            // see http://markdown-it.github.io/linkify-it/doc/#LinkifyIt.prototype.match
            const matches = linkifyItInstance.match(content) as LinkifyItMatch[] | null;
            if (matches && matches.length > 0) {
                const url = new URL(matches[0].url);
                // optional: prevent processing links with protocols like `mailto` or `ftp`
                /* if (!(url.protocol === 'http:' || url.protocol === 'https:')) {
                    return undefined;
                } */
                if (!matches[0].raw.startsWith('http') && url.protocol === 'http:') {
                    // if no protocol, set 'https' as default instead of 'http'
                    url.protocol = 'https:';
                }
                return url.href;
            }
        }
    } catch (e: unknown) {
        console.error(e);
    }
    return undefined;
};
